import { OptionProps } from '@mui/base';
import { Role } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';

export const createRoleSelectOptions = (translation: Translation): Array<OptionProps<null | Role>> => [
  {
    value: Role.ExternalGroupUser,
    label: translation.user
  },
  {
    value: Role.ExternalGroupUserManager,
    label: translation.owner
  }
];

export const getRoleOptionProp = (role: Role, translation: Translation) => {
  const roleOption = createRoleSelectOptions(translation).find((item) => item.value === role);
  if (roleOption)
    return {
      value: role,
      label: createRoleSelectOptions(translation).find((item) => item.value === role)?.label
    } as unknown as OptionProps<null | Role>;
  return undefined;
};

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
